/* eslint-disable react/jsx-no-useless-fragment */
import { Navigation } from '@cannect/new-components/atoms'
import { cloneElement } from 'react'

import { cn } from '@cannect/lib/utils'
import { Spinner } from 'phosphor-react'
import { useLocation, useHistory } from 'react-router'
import { SubMenuItem } from './SubMenuItem'
import { TLinkItem } from './types'

export const LinkItem = ({
  title,
  path,
  icon: Icon,
  submenu,
  columns,
  onClick,
  external,
  hidden = false,
  iconPlacement = 'left',
  className,
  withSheetClose,
  isLoading = false,
  hideDropdownArrow,
  disabled = false
}: TLinkItem) => {
  const location = useLocation()
  const history = useHistory()

  const currentRoute = location.pathname ?? window.location.pathname.split('/')[0].replace('/', '')

  const isActive = path === currentRoute

  const hasSubMenuActive = submenu?.filter((item) => {
    return currentRoute && item.path === currentRoute
  })

  if (hidden) return null

  if (isLoading)
    return (
      <div className="flex h-10 w-10 items-center justify-center">
        <Spinner size={32} className="animate-spin text-secondary-400" />
      </div>
    )

  return (
    <>
      {(submenu && submenu?.length > 0) || (columns && columns?.length > 0) ? (
        <>
          <Navigation.MenuTrigger
            hideDropdownArrow={hideDropdownArrow}
            className={cn(
              `${hasSubMenuActive?.length && 'font-bold underline'}`,
              disabled && 'cursor-default',
              className
            )}
            onClick={(e) => {
              if (disabled) {
                e.preventDefault()
                e.stopPropagation()
                return
              }
              if (path) {
                e.preventDefault()
                e.stopPropagation()
                if (external) {
                  window.open(path, '_blank')
                } else {
                  history.push(path)
                }
              }
              onClick?.()
            }}>
            {title}
          </Navigation.MenuTrigger>
          <SubMenuItem
            withSheetClose={withSheetClose}
            submenu={submenu}
            columns={columns}
            currentRoute={currentRoute}
          />
        </>
      ) : (
        <Navigation.MenuLink
          withSheetClose={withSheetClose}
          active={isActive}
          to={disabled ? '#' : (path ?? '#')}
          onClick={() => {
            if (disabled) return
            onClick?.()
          }}
          isExternal={external}
          className={cn(disabled && 'cursor-default', className)}>
          <span className="flex items-center gap-2">
            {Icon && iconPlacement === 'left' && cloneElement(Icon)}
            {title}
            {Icon && iconPlacement === 'right' && cloneElement(Icon)}
          </span>
        </Navigation.MenuLink>
      )}
    </>
  )
}
